export let Source;
(function (Source) {
  Source["INVOICES_EDITOR"] = "INVOICES_EDITOR";
  Source["INVOICES_HIGHLIGHT_CARD"] = "INVOICES_HIGHLIGHT_CARD";
  Source["INVOICES_SIDEBAR_CARD"] = "INVOICES_SIDEBAR_CARD";
})(Source || (Source = {}));